export default __webpack_public_path__ + "static/media/elementos-puntos.39d9f89e.svg";